import React from "react"
import { BLOCKS } from "@contentful/rich-text-types"
import styled from "styled-components"

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const Image = styled.img`
  width: 100%;
  max-width: 600px;
`

export const renderOption = {
  renderNode: {
    [BLOCKS.EMBEDDED_ASSET]: (node, children) => {
      const image = node.data.target.fields.file["en-US"]
      return (
        <ImageWrapper>
          <Image src={`https:${image.url}`} alt={image.fileName} />
        </ImageWrapper>
      )
    },
  },
}
